export default __webpack_public_path__ + "static/flowers-3-e83adc50e9bae874cf66625c45948f0d.svg";